import { render } from "./section1.vue?vue&type=template&id=2a5b0dcf&scoped=true"
import script from "./section1.vue?vue&type=script&lang=js"
export * from "./section1.vue?vue&type=script&lang=js"

import "./section1.vue?vue&type=style&index=0&id=2a5b0dcf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5b0dcf"]])

export default __exports__